import { get, post } from "../request.js";

export const ApiStudentLogin = {
  post: (obj) => {
    console.log(obj);
    return post(`/login/student/`, obj);
  },
};

export const ApiGetLogo = {
  get: () => {
    let baseurl = import.meta.env.VITE_CLiENT_DOMAIN;
    return `${baseurl}/ores/getinslogo`;
    // return `${baseurl}/login/logo/t`;
  },
};

export const ApiSetImgPassword = {
  post: (sid, obj) => {
    return post(`/login/setimgpw/${sid}`, obj);
  },
};

export const ApiImgPasswordCheck = {
  post: (sid, obj) => {
    return post(`/login/imgpw/${sid}`, obj);
  },
};

export const ApiFindPasswordByParent = {
  post: (obj) => {
    return post(`/login/findbyparent/`, obj);
  },
};

export const ApiFindParentPassword = {
  get: (email) => {
    return get(`/login/forgotpw/${email}`);
  },
};
export const ApiParentVerify = {
  get: (email) => {
    return get(`/login/verify/${email}`);
  },
};
export const ApiParentLogin = {
  post: (obj) => {
    return post(`/login/parent`, obj);
  },
};

export const ApiConfirmPassword = {
  get: (actid) => {
    return get(`/login/confirmpw/${actid}`);
  },
};

export const ApiResendVerificationCode = {
  post: (type, lang, email) => {
    return post(`/resend-verification/${type}/${lang}`, email);
  },
};
